import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Tabs, Tab } from './Tabs';
import constants from '../ndbk-constants'
import SidebarNavigation from './SidebarNavigation';
import { AddNewNodebook, PreviewNodebook } from './PreviewNodebook'
import { AddNewGroup, PreviewGroup } from './PreviewGroup'
import PreviewUser from './PreviewUser'
import PreviewNode from './PreviewNode'

class DashboardPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            nodebooks: [],
            recentNodebooks: [],
            recentlyModifiedNodebooks: [],
            recentlyActiveUsers: [],
            topViewedNodebooks: [],
            groups: [],
            users: [],
            orgs: [],
        }

        // Hashtag Meme removal for facebook
        if (window.location.hash === '#_=_') {
            window.history.replaceState
                ? window.history.replaceState(null, null, window.location.href.split('#')[0])
                : window.location.hash = '';
        }

        // This might have unforeseen consequences for google's version. It might also not have.
        if (window.location.href[window.location.href.length - 1] === '#') {
            if (window.history.replaceState) window.history.replaceState(null, null, window.location.href.split('#')[0])
        }
    }

    fetchRecentlyActiveUsers = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebooks/recently_active_users`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ recentlyActiveUsers: response.data }, () => {
                    })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchRecentlyModifiedNodebooks = () => {

        function shuffle(a) {
            var j, x, i;
            for (i = a.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = a[i];
                a[i] = a[j];
                a[j] = x;
            }
            return a;
        }

        fetch(`https://${constants.SERVER_IP}/api/nodebooks/recently_modified`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ recentlyModifiedNodebooks: shuffle(response.data) }, () => {
                    })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchNodebooks = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebooks`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebooks: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchRecentNodebooks = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebooks/recent`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ recentNodebooks: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchTopViewedNodebooks = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebooks/top_viewed`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ topViewedNodebooks: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchGroups = () => {
        fetch(`https://${constants.SERVER_IP}/api/groups`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ groups: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchUsers = () => {
        fetch(`https://${constants.SERVER_IP}/api/get_all_users`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ users: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchOrganizations = () => {
        // fetch(`https://${constants.SERVER_IP}/api/organizations`, {
        //     method: 'GET',
        //     credentials: 'include',
        // })
        //     .then((response) => response.json())
        //     .then((response) => {
        //         if (response.success) {
        //             this.setState({ orgs: response.data })
        //         }
        //         return response.success;
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });
    }

    componentWillMount() {
        this.fetchNodebooks();
        this.fetchRecentNodebooks();
        this.fetchRecentlyModifiedNodebooks();
        this.fetchRecentlyActiveUsers();
        this.fetchTopViewedNodebooks();
        this.fetchGroups();
        // this.fetchOrganizations()
        this.fetchUsers();

        document.title = constants.WEBSITE_TITLE
    }

    render() {
        var selectedTab = (['modified', 'top', 'recently-active-users'].indexOf(this.props.match.params.tab) !== -1) ? this.props.match.params.tab : 'modified'
        return (
            <div className="main">
                <SidebarNavigation {...this.props} />
                <div className="main-content">
                    <div className="container-fluid">
                        {
                            (this.state.recentlyModifiedNodebooks.length > 0)
                                ? <div className="row">
                                    {
                                        this.state.recentlyModifiedNodebooks.map(ndbk => <PreviewNodebook key={'modified' + ndbk.id} info={ndbk} />)
                                    }
                                </div>
                                : null
                        }
                    </div>
                    {/* <Tabs
                        selectedTab={selectedTab}
                        onChangeTab={selectedTab => {
                            this.props.history.push(`/dashboard/${selectedTab}`)
                        }} >
                        <Tab name="modified" title="Recently modified">
                            <div className="container-fluid">
                                {
                                    (this.state.recentlyModifiedNodebooks.length > 0)
                                        ? <div className="row">
                                            {
                                                this.state.recentlyModifiedNodebooks.filter(ndbk => (ndbk.nodes > 10)).map(ndbk => <PreviewNodebook key={'modified' + ndbk.id} info={ndbk} />)
                                            }
                                        </div>
                                        : null
                                }
                            </div>
                        </Tab>
                        <Tab name="top" title="Top viewed">
                            <div className="container-fluid">
                                {
                                    (this.state.topViewedNodebooks.length > 0)
                                        ? <div className="row">
                                            {
                                                this.state.topViewedNodebooks.filter(ndbk => (ndbk.nodes !== 0)).map(ndbk => <PreviewNodebook key={'top' + ndbk.id} info={ndbk} />)
                                            }
                                        </div>
                                        : null
                                }
                            </div>
                        </Tab>
                        <Tab name="recently-active-users" title="Recent users">
                            <div className="container-fluid">
                                {
                                    (this.state.recentlyActiveUsers.length > 0)
                                        ? <div className="row">
                                            {
                                                this.state.recentlyActiveUsers.map(user => (this.props.auth.user.id === user.id) ? null : <PreviewUser key={'recent_user' + user.id} info={user} nodescription />)
                                            }
                                        </div>
                                        : null
                                }
                            </div>
                        </Tab>
                    </Tabs> */}
                    {/* TOP */}
                    {
                        /*(this.state.topViewedNodebooks.length>0)
                            ?   <div className="row">
                                    <div className="col-lg-12">
                                        <h2>Most popular</h2>
                                    </div>
                                    {
                                        this.state.topViewedNodebooks.slice(0,6).map(ndbk=><PreviewNodebook key={ndbk.id} info={ndbk} />)
                                    }
                                </div>
                            : null*/
                    }
                    {/* USERS */}
                    {/*<div className="row">
                            <div className="col-lg-12">
                                <h2>All users</h2>
                            </div>
                        </div>
                        <div className="row">
                        {
                            this.state.users.map(user=><PreviewUser key={user.id} info={user} nodescription/>)
                        }
                        </div>*/}

                    {/* <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="row category">
                                    <div className="col-lg-12">
                                        <h5>Computer graphics</h5>
                                    </div>
                                    <PreviewNodebook nodatasohereisid="139" fullSize/>
                                    <PreviewNodebook nodatasohereisid="407" fullSize/>
                                    {
                                        this.state.users.filter(u=>u.username==='draganokan').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }

                                </div>

                                <div className="row category">
                                    <div className="col-lg-12">
                                        <h5>Physics</h5>
                                    </div>
                                    <PreviewNodebook nodatasohereisid="427" fullSize/>
                                    {
                                        this.state.users.filter(u=>u.username==='diogoaguiam'||u.username==='ovuka.v').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="row category">
                                    <div className="col-lg-12">
                                        <h5>Cryptocurrencies</h5>
                                    </div>
                                    <PreviewNodebook nodatasohereisid="428" fullSize/>
                                    {
                                        this.state.users.filter(u=>u.username==='mocanu.d'||u.username==='Jovan').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }
                                    <PreviewNodebook nodatasohereisid="429" fullSize/>

                                </div>

                                <div className="row category">
                                    <div className="col-lg-12">
                                        <h5>Biomedical engineering</h5>
                                    </div>
                                    {
                                        this.state.users.filter(u=>u.username==='Jovan'||u.username==='isakovic.m').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="row category">
                                    <div className="col-lg-12">
                                        <h5>Machine learning</h5>
                                    </div>
                                    {
                                        this.state.users.filter(u=>u.username==='pavlovic.a'||u.username==='nonkovic.n').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }
                                    <PreviewNodebook nodatasohereisid="426" fullSize/>
                                    {
                                        this.state.users.filter(u=>u.username==='velickovic.p').map(user=><PreviewUser key={user.id} info={user} nodescription fullSize/>)
                                    }
                                    <PreviewNodebook nodatasohereisid="162" fullSize/>
                                </div>
                            </div>
                        </div> */}

                </div>
            </div>
        );
    }
}

export default withRouter(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/DashboardPage.js